import ToolkitMixin from '@/app/mixins/toolkit/item';

export default {
  name: 'inv-strat-borrowing',
  mixins: [ToolkitMixin],
  computed: {
    /**
    * NOTE: Backwards capability required as at 20/04/2021 changed to m-radio
    * but data stored not consistent with this approach
    */
    borrowing: {
      get() {
        return this.getItem.borrowing === 'true' ? 'Yes' : 'No';
      },
      set(value) {
        this.setItem({
          borrowing: value === 'Yes' ? 'true' : 'false',
        });
      },
    },
  },
};
